"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.EventType = void 0;
var EventType = exports.EventType = function (a) {
  return a.Evaluation = "evaluation", a.ConfigurationUpdate = "configurationUpdate", a;
}({});